import { render, staticRenderFns } from "./voucherShopGoodsDlg.vue?vue&type=template&id=0f36d997&scoped=true"
import script from "./voucherShopGoodsDlg.vue?vue&type=script&lang=js"
export * from "./voucherShopGoodsDlg.vue?vue&type=script&lang=js"
import style0 from "./voucherShopGoodsDlg.vue?vue&type=style&index=0&id=0f36d997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f36d997",
  null
  
)

export default component.exports